import type { ReactNode } from 'react';
import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContextProvider } from 'app/context/HotelContext/ModernHotelContext';
import { ModernTaskCenterProvider } from 'app/context/TaskCenterContext/ModernTaskCenterContext';
import { TaskCenterProvider } from 'app/context/TaskCenterContext/TaskCenterContext';

export const TaskCenterWrapper = ({ children }: { children: ReactNode }) => {
  const { hotelInfo } = useContext(HotelContext);

  return hotelInfo?.isLegacy ? (
    <TaskCenterProvider>{children}</TaskCenterProvider>
  ) : (
    <ModernHotelContextProvider>
      <ModernTaskCenterProvider>{children}</ModernTaskCenterProvider>
    </ModernHotelContextProvider>
  );
};
